export default __webpack_public_path__ + "static/media/arrow-left.e49358f2.svg";